@if (bookingList(); as viewModel) { @if(viewModel.horizontalMenuItems.length>0) {
<div class="marginBottom-l">
  <vy-menu-horizontal [items]="bookingList().horizontalMenuItems">
    <vy-avatar-name
      header-left
      [avatarInput]="bookingList().avatar"
      [avatarCustomName]="'common.horizontal_nav_bar.salutation' | translate: {user:bookingList().userName }"
    ></vy-avatar-name>
  </vy-menu-horizontal>
</div>
}

<h1 class="headingXXL marginBottom-l">{{'booking_list_component.title_credit' | translate}}</h1>

<vy-box [boxLevel]="BoxLevel.LEVEL_MAIN">
  <ng-container box-content>
    <vy-box [boxLevel]="BoxLevel.LEVEL_ONE">
      <ng-container box-content>
        <div class="row marginBottom-xl marginLeft-xs">
          <vy-segmented-controls [options]="quickFilters" (optionEmitter)="changeQuickFilter($event)">
          </vy-segmented-controls>
        </div>

        <div class="count-buttons-align">
          <div class="marginLeft-s">
            @if ((viewModel.totalBookingsFound ?? 0) > 1) {
            <p
              [innerHTML]="'booking_list_component.found_bookings.plural' | translate: { count:
              viewModel.totalBookingsFound }"
            ></p>
            } @else if(viewModel.totalBookingsFound === 1) {
            <p [innerHTML]="'booking_list_component.found_bookings.singular' | translate"></p>
            }
          </div>
          <div class="marginRight-s">
            <app-export-booking-list
              [typeBookings]="'WithCredit'"
              (loading)="$event ? startLoading(): stopLoading()"
            ></app-export-booking-list>
          </div>
        </div>

        <div>
          <vy-loader [whiteBackground]="true" [parentRelative]="true"></vy-loader>
          @if ((viewModel.bookingsTableData?.bodyData?.length ?? 0) > 0) {

          <app-booking-table [tableConfig]="viewModel.bookingsTableData" (sort)="onSort($event)"></app-booking-table>

          <vy-paginator
            [currentPage]="viewModel.paginationInfo.currentPage ?? 0"
            [totalPages]="viewModel.paginationInfo.totalPages ?? 0"
            (pageChange)="changePage($event)"
          ></vy-paginator>

          } @else {

          <div class="marginTop-xl marginBottom-xl">
            <vy-box>
              <ng-container box-content>
                <div class="text-center padding-l">
                  <h3 class="headingL marginBottom-l">
                    {{ 'booking_list_component.no_filtered_bookings' | translate }}
                  </h3>
                  <img [src]="notFoundBookingsImage" alt="" />
                </div>
              </ng-container>
            </vy-box>
          </div>

          }
        </div>
      </ng-container>
    </vy-box>
  </ng-container>
</vy-box>
}
